module.exports = __webpack_public_path__ + "static/media/ico-step5-time.e9bc3a59.svg";